export const LIVECATEGORY = [
  {
    value: 'all',
    label: '全部',
  },
  {
    value: 'important',
    label: '重要',
  },
];

export const INTERVAL_TYPE = {
  hours: 'min1',
  daily: 'day',
  weekly: 'week',
  monthly: 'month',
};

export const SVIP_ICONS = {
  BLACK_GOLD:
    'https://cdn.gelonghui.com/static/web/image_tags_text_premier_vip_2x.png',
  SVIP: 'https://cdn.gelonghui.com/static/web/image_tags_text_svip_2x.png',
};

export const FILE_ICONS = {
  pdf: 'https://cdn.gelonghui.com/static/mobile/image_chat_PDF%402x.png',
  doc: 'https://cdn.gelonghui.com/static/mobile/image_chat_doc%402x.png',
  docx: 'https://cdn.gelonghui.com/static/mobile/image_chat_doc%402x.png',
  xlsx: 'https://cdn.gelonghui.com/static/mobile/image_chat_excel%402x.png',
  xls: 'https://cdn.gelonghui.com/static/mobile/image_chat_excel%402x.png',
  ppt: 'https://cdn.gelonghui.com/static/mobile/image_chat_ppt%402x.png',
  mp3: 'https://cdn.gelonghui.com/static/mobile/image_chat_music%402x.png',
  mp4: 'https://cdn.gelonghui.com/static/mobile/image_chat_music%402x.png',
  m3u8: 'https://cdn.gelonghui.com/static/mobile/image_chat_music%402x.png',
  unknown:
    'https://cdn.gelonghui.com/static/mobile/image_chat_unknown%402x.png',
};

export const MomentTypeIcons = {
  SVIP: {
    icon: 'https://cdn.gelonghui.com/static/images/image_login_svip_n2x.png',
    name: 'SVIP',
  },
  BLACK_GOLD: {
    icon: 'https://cdn.gelonghui.com/static/images/image_login_svip_b2x.png',
    name: '黑金VIP',
  },
};

export const MomentRoleIcons = {
  OWNER:
    'https://cdn.gelonghui.com/static/web/activity/image_tags_text_circleowner_2x.png',
  HONORED_GUEST:
    'https://cdn.gelonghui.com/static/web/activity/image_tags_text_guest_2x.png',
};

export const LiveStatusMap = {
  1: {
    icon: 'https://cdn.gelonghui.com/static/mobile/huiluyan/icon_appointment_extrasmall_2x.png',
    text: '预约中',
  },
  2: {
    icon: 'https://cdn.gelonghui.com/static/mobile/huiluyan/icon_live_extrasmall_2x.png',
    text: '直播中',
  },
  3: {
    icon: 'https://cdn.gelonghui.com/static/mobile/huiluyan/icon_visible_extrasmall_2x.png',
    text: '回放中',
  },
  4: {
    icon: 'https://cdn.gelonghui.com/static/mobile/huiluyan/icon_notvisible_extrasmall_2x.png',
    text: '不支持回放',
  },
  [-1]: {
    icon: 'https://cdn.gelonghui.com/static/mobile/huiluyan/icon_notvisible_extrasmall_2x.png',
    text: '回放生成中',
  },
};
